module.exports = __webpack_public_path__ + "media/assets/images/blog/iot_horeca-small-7e21b7d5d2406c450ce4038addb5a1d2.png";